<nz-space class="mobile-report-control">
  <div class="report-control">
    <app-gl-acc-select [(ngModel)]="from" (ngModelChange)="fromChange.emit($event)" valueField="code" labelField="code" [includeAplac]="this.includeAplac"
      [includeDACandCCAC]="this.includeDACandCCAC" [allowClear]="true" #accFrom>
    </app-gl-acc-select>
    <app-view-item [text]="accFrom.selected?.name"></app-view-item>
  </div>
  <span class="text-center pt-md">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <div class="report-control">
    <app-gl-acc-select [(ngModel)]="to" (ngModelChange)="toChange.emit($event)" valueField="code" labelField="code" [includeAplac]="this.includeAplac"
      [includeDACandCCAC]="this.includeDACandCCAC" [allowClear]="true" #accTo>
    </app-gl-acc-select>
    <app-view-item [text]="accTo.selected?.name">
    </app-view-item>
  </div>

</nz-space>
